import { valueMatched } from '../_input_match_utils'

export type SplitSeparator = 'space' | 'comma' | 'newline'
export type ForceCase = 'up' | 'down' | null

export function separatorRegex(separators: SplitSeparator[] = []): RegExp | null {
  const patterns: string[] = []

  if (separators.includes('comma')) patterns.push(',')
  if (separators.includes('newline')) patterns.push('\\r?\\n+')
  if (separators.includes('space')) patterns.push('[ \\t]+')

  if (patterns.length === 0) return null

  return new RegExp(patterns.join('|'))
}

export function splitInput(rawValue: string, separators: SplitSeparator[] = []): string[] {
  const regex = separatorRegex(separators)
  if (regex === null) return [rawValue]

  return rawValue.split(regex)
}

export function normalizeToken(value: string, match: string | null, forceCase: ForceCase): string {
  let normalized = value.trim()
  normalized = valueMatched(normalized, match, null)

  if (forceCase === 'up') return normalized.toUpperCase()
  if (forceCase === 'down') return normalized.toLowerCase()

  return normalized
}

export function valuesToAdd(
  rawValue: string,
  separators: SplitSeparator[] = [],
  match: string | null = null,
  forceCase: ForceCase = null
): string[] {
  if (rawValue === '') return []

  const normalizedValues = splitInput(rawValue, separators)
    .map(value => normalizeToken(value, match, forceCase))
    .filter(value => value !== '')

  return normalizedValues
}
